import api from './api';

export const getCategoriesApi = (params) => api().get('/lender-company-categories', { params });
export const addNewCategoryApi = (data) => api().post('/lender-company-categories', data);
export const deleteCategoriesApi = (params) => api().delete('/lender-company-categories', { params });
export const updateCategoriesApi = (params) => api().put(`/lender-company-categories/${params.id}`, params.values);
